import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Notification Settings</h3>
                <p className="text-sm text-gray-600">
                    Configure how and when you receive alerts for fleet activities.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Role-Based Alerts</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Admin:</strong> Toggle this to enable/disable alerts for workspace administrators.</li>
                    <li><strong>Manager:</strong> Toggle this to enable/disable alerts for fleet managers.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Notification Types</h4>
                <p className="text-sm text-gray-600">
                    Customize notifications for specific events such as fuel logs, vehicle issues, or service reminders. You can enable or disable these settings globally for your account.
                </p>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Updating Settings</h4>
                <p className="text-sm text-gray-600">
                    Changes made here are applied in real-time. A success message will appear once your preferences are saved.
                </p>
            </section>
        </div>
    );
};

export default Help;
